import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Button } from '@/components/ui/button';

import ActivityCertificationsForm from './components/coachActivityQualificationsPage/ActivityCertificationsForm';

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter
} from '@/components/ui/card';

import { useApplication } from '@/data/application';
import { useCoachSelf } from '@/data/coach';
import { useCoachActivity } from '@/data/coachActivity';
import { useListCertifications } from '@/data/certification';

const APPLICATION_STEP_KEY = 'qualifications';

const CoachActivityQualificationsPage = () => {
  const coach = useCoachSelf();
  const [dirtyCertifications, setDirtyCertifications] = useState(new Set());
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const applicationStructure = useApplication({
    coachActivityId: params.coachActivityId
  });
  const certifications = useListCertifications({
    coachActivityId: params.coachActivityId
  });

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }
  if (coachActivity.isLoading && !coachActivity.coachActivity) {
    return <PageLoading />;
  }
  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }

  const handleDirtyChange = ({ certificationId, isDirty }) => {
    setDirtyCertifications((prev) => {
      const newSet = new Set(prev);
      if (isDirty) {
        newSet.add(certificationId);
      } else {
        newSet.delete(certificationId);
      }
      return newSet;
    });
  };

  const step = applicationStructure.data.steps.find(
    (step) => step.key === APPLICATION_STEP_KEY
  );

  const isDirty = dirtyCertifications.size > 0;
  const isContinueDisabled = certifications.data
    ? certifications.data.some(
        (cert) => !cert.documents || cert.documents.length === 0 || !cert.name
      )
    : true;

  return (
    <Page>
      <BackButton to={`/application/${params.coachActivityId}`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>
            {coachActivity.data.activity.title} Qualifications
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ActivityCertificationsForm onDirtyChange={handleDirtyChange} />
        </CardContent>
        <CardFooter>
          <div className="flex justify-end w-full">
            {isDirty || isContinueDisabled ? (
              <Button disabled>Continue</Button>
            ) : (
              <Link to={step.nextStepLink}>
                <Button>Continue</Button>
              </Link>
            )}
          </div>
        </CardFooter>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default CoachActivityQualificationsPage;
